"use client";

import {
  PointerInteractionMediaProvider,
  usePointerInteractionMediaOptional,
} from "@/components/feature/pointer-interaction-media/PointerInteractionMediaProvider";
import type { ReactNode } from "react";

/**
 * Ensures pointer-interaction media queries are evaluated once per tree.
 * - If an upstream provider exists, it reuses that value.
 * - Otherwise, it creates a local provider.
 */
export function PointerInteractionAutoProvider({ children }: { children: ReactNode }) {
  const existing = usePointerInteractionMediaOptional();

  if (existing) {
    return <>{children}</>;
  }

  return <PointerInteractionMediaProvider>{children}</PointerInteractionMediaProvider>;
}
